<full-calendar #fullcalendar locale="locales" [options]="options"></full-calendar>
